import { Inject, Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApplicationStateService } from 'src/app/services/application-state.service';

import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { LocationService } from 'src/app/services/location/location.service';
import { InvoicingService } from 'src/app/services/invoicing/invoicing.service';

import { Invoice } from 'src/app/models/invoice.interface';
import { Transaction } from 'src/app/models/transaction.interface';
import { AccountLocation } from 'src/app/models/location.interface';
import { SaleResponseStatusType } from 'src/app/models/transaction-enums.model';
import { translate } from '@jsverse/transloco';

import { Invoicing } from 'src/app/models/invoicing.interface';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-pay',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicePayComponent implements OnInit {
  
  invoicing!: Invoicing;
  location!: AccountLocation;
  public invoice: Invoice | undefined;
  public transaction: Transaction | undefined;
  public amount: string | undefined;

  public activePaymentType: 'credit-card'|'gift-card' = 'credit-card';
  public showAlert = false;
  public alertMessage = '';
  public alertButtonText = '';
  public alertType: 'info' | 'success' | 'error' | 'warning' = 'error';
  public showSpinner = false;

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private applicationState: ApplicationStateService,
    private invoiceService: InvoiceService,
    private transactionService: TransactionService,
    private locationService: LocationService,
    private readonly invoicingService: InvoicingService,
    private readonly renderer: Renderer2) { }

  public alertButtonListener(event: any): void {}

  ngOnInit(): void {
    this.invoice = this.invoiceService.invoice;
    this.invoicing = this.invoicingService.invoicing;
    this.location = this.locationService.location;
    this.transaction = this.transactionService.transaction;
    this.amount = this.transactionService.transaction.balanceDueFixedPointFormat;

    this.loadComplianceScript();
  }

  public paymentCallInProgress(showSpinner: boolean): void {
    if (showSpinner) {
      this.showAlert = true;
      this.showSpinner = true;
      this.alertMessage = translate('ProcessingPayment');
    }
    else {
      this.showAlert = false;
      this.showSpinner = false;
    }
  }

  public paymentCallback(resp: any): void {

    this.showSpinner = false;

    switch (resp.saleResponseStatusTypeId) {
      case SaleResponseStatusType.PartialApproval:
        this.alertType = 'info';
        this.alertButtonText = translate('Continue');
        this.alertMessage = translate('PartialApprovalMessage', { value1: resp.approvedAmountCurrencyFormat , value2: resp.requestedAmountCurrencyFormat });

        this.alertButtonListener = (): void => {
          this.applicationState.nextStep('confirmation');

          if (this.activeRoute.parent) {
            this.router.navigateByUrl(`/invoice/${this.invoiceTrackingKey}/confirmation`);
          }
        };

        break;
      case SaleResponseStatusType.Approval:
        this.showAlert = false;
        this.applicationState.nextStep('confirmation');

        if (this.activeRoute.parent) {
          this.router.navigateByUrl(`/invoice/${this.invoiceTrackingKey}/confirmation`);
        }

        break;
      case SaleResponseStatusType.InsufficientFundsDeclined:
        this.alertButtonText = translate('OK');
        this.alertType = 'error';
        this.alertMessage = translate('InsufficientFundsMessage');
        this.alertButtonListener = (): void => { this.showAlert = false; };

        break;
      case SaleResponseStatusType.BadRequest:
        this.alertButtonText = translate('OK');
        this.alertType = 'warning';
        this.alertMessage = translate('GenericGatewayErrorMessage');
        this.alertButtonListener = (): void => { this.showAlert = false; };

        break;
      }
  }

  private loadComplianceScript(): void {
    const jscramblerUrl = environment.jscramblerUrl;

    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'src', jscramblerUrl);
    this.renderer.setAttribute(script, 'async', 'true');
    this.renderer.appendChild(document.head, script);
  }
}
